// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* add css styles here (optional) */

/* .wrapper {
    display: block;
    font-family: sans-serif;
    text-align: center;
    margin: 0 auto;
    position: relative;
  } */

.BeHaH6KSmZxhjm47fAuV {
  width: 100%;
}

.PkxIx5z6eIYuQCE4MX7V .b66he86q2cD81PrnlvBa {
  opacity: 0.3;
}

.PkxIx5z6eIYuQCE4MX7V .zEdxsTNjycYuMjcDMr9X {
  opacity: 1;
}

.H6JtPBkKoTn0OZl6YbYn {
  position: absolute;
  left: 0;
  right: 0;
  width: 75%;
  max-width: 75%;
  margin: 0 auto;
  text-shadow: 0px 1px 1px #bfbfbf;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.SkgnPiVOUqkXE5W1UAX_ {
  font-size: 30px;
}

.H6JtPBkKoTn0OZl6YbYn .GID6TgwyGig1g82nf7uK {
  padding: 0 4px;
}

.dPRMObWzRNjumsBtbIBv {
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .dPRMObWzRNjumsBtbIBv {
    margin-bottom: 1.5rem;
  }
}

.yhkkfrWK2JhKwvgwSBhw {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.yhkkfrWK2JhKwvgwSBhw > * {
  margin-bottom: 1rem;
}

.yhkkfrWK2JhKwvgwSBhw .gMuQgcuYzhhPUDvHc1HH {
  font-size: 18px;
  font-weight: 300;
}

.yhkkfrWK2JhKwvgwSBhw .LLoTNRYvQHCognADKHeg {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.yhkkfrWK2JhKwvgwSBhw .Da4fl7CLDw1lJ2vrjPK2 {
  font-weight: 600;
  color: #243c88;
  font-size: 30px;
}

.yhkkfrWK2JhKwvgwSBhw .LueyJxf7kUgHs9uheStw {
  display: flex;
  align-items: center;
  margin-left: 1rem;
  padding: 0.5rem 1rem;
  background-color: #28a745;
  opacity: 0.1;
  border-radius: 5px;
}

.yhkkfrWK2JhKwvgwSBhw .LueyJxf7kUgHs9uheStw .xjDc_17wr1R6WWnDaK4W {
  font-size: 16px;
  font-weight: 300;
  color: #28a745;
}

.yhkkfrWK2JhKwvgwSBhw .oU3TxpYUKku7zK2YN7cj {
  display: flex;
  align-items: center;
  margin-top: 1rem;
}

.yhkkfrWK2JhKwvgwSBhw .oU3TxpYUKku7zK2YN7cj .jHX3o2nAseZcSraNzwuz {
  width: 10px;
  height: 10px;
  background-color: #dc3545;
  border-radius: 50%;
  margin-right: 0.5rem;
}

.yhkkfrWK2JhKwvgwSBhw .oU3TxpYUKku7zK2YN7cj .Qv5ElUFHGCLImIy1lSsb {
  font-size: 16px;
  color: #7b8794;
}
`, "",{"version":3,"sources":["webpack://./src/components/score/style.module.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;;;;;;KAMK;;AAEL;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,cAAc;EACd,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* add css styles here (optional) */\n\n/* .wrapper {\n    display: block;\n    font-family: sans-serif;\n    text-align: center;\n    margin: 0 auto;\n    position: relative;\n  } */\n\n.scoreWrapper {\n  width: 100%;\n}\n\n.rangeSvg .pathEl {\n  opacity: 0.3;\n}\n\n.rangeSvg .pathEl--active {\n  opacity: 1;\n}\n\n.scoreValue {\n  position: absolute;\n  left: 0;\n  right: 0;\n  width: 75%;\n  max-width: 75%;\n  margin: 0 auto;\n  text-shadow: 0px 1px 1px #bfbfbf;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.value {\n  font-size: 30px;\n}\n\n.scoreValue .separator {\n  padding: 0 4px;\n}\n\n.custom-col {\n  margin-right: auto;\n  margin-left: auto;\n  margin-bottom: 1rem;\n}\n\n@media (min-width: 768px) {\n  .custom-col {\n    margin-bottom: 1.5rem;\n  }\n}\n\n.score-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n}\n\n.score-container > * {\n  margin-bottom: 1rem;\n}\n\n.score-container .score-label {\n  font-size: 18px;\n  font-weight: 300;\n}\n\n.score-container .score-value-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.score-container .score-value {\n  font-weight: 600;\n  color: #243c88;\n  font-size: 30px;\n}\n\n.score-container .score-badge {\n  display: flex;\n  align-items: center;\n  margin-left: 1rem;\n  padding: 0.5rem 1rem;\n  background-color: #28a745;\n  opacity: 0.1;\n  border-radius: 5px;\n}\n\n.score-container .score-badge .score-percent {\n  font-size: 16px;\n  font-weight: 300;\n  color: #28a745;\n}\n\n.score-container .score-status {\n  display: flex;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n.score-container .score-status .status-circle {\n  width: 10px;\n  height: 10px;\n  background-color: #dc3545;\n  border-radius: 50%;\n  margin-right: 0.5rem;\n}\n\n.score-container .score-status .status-label {\n  font-size: 16px;\n  color: #7b8794;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scoreWrapper": `BeHaH6KSmZxhjm47fAuV`,
	"rangeSvg": `PkxIx5z6eIYuQCE4MX7V`,
	"pathEl": `b66he86q2cD81PrnlvBa`,
	"pathEl--active": `zEdxsTNjycYuMjcDMr9X`,
	"scoreValue": `H6JtPBkKoTn0OZl6YbYn`,
	"value": `SkgnPiVOUqkXE5W1UAX_`,
	"separator": `GID6TgwyGig1g82nf7uK`,
	"custom-col": `dPRMObWzRNjumsBtbIBv`,
	"score-container": `yhkkfrWK2JhKwvgwSBhw`,
	"score-label": `gMuQgcuYzhhPUDvHc1HH`,
	"score-value-container": `LLoTNRYvQHCognADKHeg`,
	"score-value": `Da4fl7CLDw1lJ2vrjPK2`,
	"score-badge": `LueyJxf7kUgHs9uheStw`,
	"score-percent": `xjDc_17wr1R6WWnDaK4W`,
	"score-status": `oU3TxpYUKku7zK2YN7cj`,
	"status-circle": `jHX3o2nAseZcSraNzwuz`,
	"status-label": `Qv5ElUFHGCLImIy1lSsb`
};
export default ___CSS_LOADER_EXPORT___;
